import type { ConfirmPasswordResetPayload, ConfirmPasswordResetResponse } from '@vy/api-definition';
import { ConfirmPasswordResetResponseSchema } from '@vy/api-definition';
import { useMutation, type UseMutationOptions } from 'react-query';
import { getPublicApi } from '../../services/api';

export function useConfirmPasswordReset(
  options?: UseMutationOptions<ConfirmPasswordResetResponse, unknown, ConfirmPasswordResetPayload>,
) {
  return useMutation({
    mutationFn: async ({ email, newPassword, verificationCode }) => {
      const api = getPublicApi();

      const confirmPasswordResetResponse = await api.confirmPasswordReset({
        confirmPasswordResetRequest: { email, newPassword, verificationCode },
      });

      return ConfirmPasswordResetResponseSchema.parse(confirmPasswordResetResponse);
    },
    ...options,
  });
}
